import React from 'react';
import SideNavbar from '../../components/Navbar/SideNavbar';
import Header from '../../components/Header/Header';
import DynamicPricingList from '../../components/DynamicPricing/DynamicPricingList';

const DynamicPricingListing = () => {
    return (
        <div className="flex mainWrapper w-full">
            <div className="sidenav-wrapper">
                <SideNavbar />
            </div>
            <div className="right-container">
                <div className="header-container">
                    <Header />
                </div>
                <div className="body-container">
                    <DynamicPricingList />
                </div>
            </div>
        </div>
    );
}

export default DynamicPricingListing;
